import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnimateModule, GtmClickDirective, TrainingBrand, WwwRouteSlug } from '@pro-connect/shared';
import { AboutUsSection } from '../../models/about-us-section';

@Component({
  selector: 'app-about-us-brands',
  templateUrl: './about-us-brands.component.html',
  styleUrls: ['./about-us-brands.component.scss'],
  imports: [RouterModule, NgOptimizedImage, AnimateModule, GtmClickDirective],
})
export class AboutUsBrandsComponent {
  protected readonly WwwRouteSlug = WwwRouteSlug;
  protected readonly AboutUsSection = AboutUsSection;
  protected readonly Brand = TrainingBrand;
}
